import React from "react";

const PriceSummary = ({ employees, plan, t }) => {
  if (!plan) return null;

  const pricePerEmployee = Number(
    plan?.monthlyPrice || plan?.price || 0
  );

  const months =
    plan?.id === "yearly"
      ? 12
      : plan?.id === "halfYear"
        ? 6
        : 1;

  // إجمالي الشهر لكل الموظفين
  const monthlyTotal = pricePerEmployee * employees;

  // الإجمالي النهائي حسب الباقة
  const total = monthlyTotal * months;

  const currency = t("pricing.calculator.currency", "ج.م");

  return (
    <div className="mb-6 rounded-xl bg-gray-100 p-4">
      {/* Monthly calculation - once only */}
      <div className="mb-3 flex justify-end text-sm text-gray-500">
        <span>
          {employees} × {pricePerEmployee} {currency}
        </span>
      </div>

      {/* Old design */}
      <div className="flex items-start justify-between gap-4">
        {/* Total */}
        <div>
          <p className="text-xs text-gray-500">
            {t("pricing.calculator.total", "الإجمالي")}
          </p>

          <p className="text-primary text-xl font-bold">
            {total.toLocaleString()} {currency}
          </p>

          {months > 1 && (
            <p className="mt-1 text-xs text-gray-400">
              {monthlyTotal.toLocaleString()} × {months}{" "}
              {months === 12
                ? t("pricing.calculator.month", "شهر")
                : t("pricing.calculator.months", "أشهر")}
            </p>
          )}
        </div>

        {/* Per employee */}
        <div className="text-right">
          <p className="text-xs text-gray-500">
            {plan?.id === "monthly"
              ? t("pricing.calculator.perEmployee", "لكل موظف")
              : t(
                  "pricing.calculator.perEmployeeMonthly",
                  "لكل موظف / شهري"
                )}
          </p>

          <p className="text-primary font-medium">
            {pricePerEmployee.toLocaleString()} {currency}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;